module.exports = __webpack_public_path__ + "media/images/flags/32/Ecuador-5807ce7e281cf3fd8dce9da5b41e8cee.png";